import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getBaseApiPath } from '@/app/common/api/config';
import type {
  DashboardNotifsResponse,
  FeaturesBaseResponse,
  FeaturesResponse,
  PanelsResponse
} from '@/app/Report/types/priceApiTypes';

const nocoToken = import.meta.env.VITE_NOCO_TOKEN;

const nocoBaseQuery = fetchBaseQuery({
  baseUrl: getBaseApiPath(),
  prepareHeaders: headers => {
    if (nocoToken) {
      headers.set('Authorization', `Bearer ${nocoToken}`);
    }
    return headers;
  }
});

const priceNewApi = createApi({
  reducerPath: 'priceNewApi',
  baseQuery: nocoBaseQuery,
  endpoints: build => ({
    getPanels: build.query<PanelsResponse, void>({
      query: () => `/nocoapi/mz_panels:list?pageSize=30`
    }),
    getFeatures: build.query<FeaturesResponse, void>({
      query: () => `/nocoapi/mz_panels_feature:list?pageSize=100`
    }),
    getFeaturesBase: build.query<FeaturesBaseResponse, void>({
      query: () => `/nocoapi/mz_panels_feature_base:list`
    }),
    getDashboardNotifs: build.query<DashboardNotifsResponse, void>({
      query: () => `/Notif_Dashboard/records/?perPage=10&sort=-order`
    })
  })
});

export const {
  useGetFeaturesQuery,
  useGetPanelsQuery,
  useGetFeaturesBaseQuery,
  useGetDashboardNotifsQuery
} = priceNewApi;

export default priceNewApi;
